export default __webpack_public_path__ + "static/assets/12fd44910fedc5b99761e024ddf05c59.png";